module.exports = __webpack_public_path__ + "static/media/arith.3b3c9c32.png";